import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './fonts.css';
import './App.css';
import Home from './components/Home';
import JulianPage from './components/JulianPage';
import Imprint from './components/Imprint';
import Datenschutz from './components/Datenschutz';
import AGB from './components/AGB';
import Access from './components/Access';
import AuthForm from './components/AuthForm';
import ApplicationDashboard from './components/ApplicationDashboard';
import PasswordProtection from './components/PasswordProtection';
import ScrollToTop from './components/ScrollToTop';

function App() {
  React.useEffect(() => {
    let ticking = false;
    
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const header = document.querySelector('.app-header');
          if (header) {
            if (window.scrollY > 100) {
              header.classList.add('scrolled');
            } else {
              header.classList.remove('scrolled');
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <Router>
      <ScrollToTop />
      <div className="app">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/julian" element={<JulianPage />} />
          <Route path="/imprint" element={<Imprint />} />
          <Route path="/privacy" element={<Datenschutz />} />
          <Route path="/terms" element={<AGB />} />
          <Route path="/access" element={<Access />} />
          <Route path="/auth" element={<AuthForm />} />
          <Route path="/teamdashboard" element={
            <PasswordProtection>
              <ApplicationDashboard />
            </PasswordProtection>
          } />
        </Routes>
    </div>
    </Router>
  );
}

export default App;
